import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { forgotPassword } from "../../api/auth";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (!email) {
      setError("Please enter your email address.");
      return;
    }

    setLoading(true);
    try {
      await forgotPassword(email);
      setSubmitted(true);
    } catch (err: any) {
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-surface-900 flex items-center justify-center p-6">
        <div className="w-full max-w-sm text-center">
          <div className="mb-6 p-3 rounded-lg bg-quantum-500/10 border border-quantum-500/30">
            <p className="text-body text-quantum-400">Check your email</p>
          </div>
          <p className="text-body text-text-secondary mb-6">
            If an account exists with that email, we've sent a password reset link.
            The link expires in 1 hour.
          </p>
          <button onClick={() => navigate("/login")} className="btn-primary px-6 py-2">
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-surface-900 flex items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="/quantum-small.png" alt="TotalView" className="w-16 h-16 mx-auto mb-4" />
          <h1 className="text-h1 text-text-primary mb-2">Forgot Password</h1>
          <p className="text-body text-text-secondary">
            Enter your email and we'll send you a link to reset your password.
          </p>
        </div>

        {error && (
          <div className="mb-4 p-3 rounded-lg bg-health-500/10 border border-health-500/30">
            <p className="text-body-sm text-health-400 text-center">{error}</p>
          </div>
        )}

        <form className="space-y-4" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="email" className="input-label">Email Address</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              className="input"
              disabled={loading}
              autoComplete="email"
            />
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full py-3">
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>

        <p className="mt-6 text-center">
          <button
            onClick={() => navigate("/login")}
            className="text-body-sm text-quantum-400 hover:text-quantum-300"
          >
            Back to Login
          </button>
        </p>
      </div>
    </div>
  );
}
